/**
 * Shared Sign Up / child profile modal chrome (Event Calendar account signup + Children add/edit).
 * Keep width and form class in one place so both flows stay visually aligned.
 */
export const ACCOUNT_SIGNUP_MODAL_MAX_WIDTH = 860;

/** Apply on ModalShell `bodyClassName` (and any nested `.modal-form`) for signup field rhythm. */
export const ACCOUNT_SIGNUP_FORM_CLASS = "modal-form EventCalendar-modal-form";
